
import Vue from "vue";
import Loader from "@/components/Multiloader.vue";
import Leitung from "../components/Leitung.vue";
import Section from "@/components/Section.vue";

export default Vue.extend({
  name: "Messwerte",
  components: {
    Loader,
    Leitung,
    Section
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      messleitungenView: {
        name: "gus_messwerte_messleitungen",
        condition: "MESSST_NR=number:" + this.id
      },
      leitung_nr: 0 as number | null,
      messleitungen: [] as any[]
    };
  },
  computed: {
    messwerteView: function() {
      return {
        name: "gus_messwerte_messwerteaktuell",
        condition: [
          "MESSST_NR=number:" + this.id,
          (this as any).leitung_nr
            ? "leitung_nr=number:" + (this as any).leitung_nr
            : ""
        ]
      };
    }
  },
  methods: {
    loadedLeitungen(messleitungen: any[]) {
      this.$nextTick(() => (this.messleitungen = messleitungen));
      //	LUWGA-1379: LeitungsNr. Auswahl entfernen, nurnoch nr 23 anzeigen
      if (!this.leitung_nr) {
        if (this.id == "2511510500") {
          if (messleitungen != null && messleitungen.length > 0) {
            this.leitung_nr = 23;
          }
        } else {
          if (messleitungen != null && messleitungen.length > 0) {
            const leitung = messleitungen[0].leitung_nr;
            this.leitung_nr = leitung == null ? leitung : 1;
          } else this.leitung_nr = null;
        }
      }
      //TODO: Fehler Handling von Stage Umgebung einbauen, Siehe Issue #89
    },
    getDatumMap: function(data: any[]) {
      return new Map([
        ["Datum:", data[0].str_datum],
        ["Uhrzeit (MEZ)", data[0].uhrzeit + " Uhr"]
      ]);
    },
    toNumber(v: any) {
      if (isNaN(v)) return 0;
      else {
        return v.toFixed(1).replace(".", ",");
      }
    },
    getMesswerteMap: function(data: any[]) {
      return new Map(
        data.map(messung => [
          messung.stoff_bezeichnung,
          this.toNumber(messung.messwert) +
            " " +
            (messung.stoff_einheit != null ? messung.stoff_einheit : " ")
        ])
      );
    }
  }
});
